// extracted by mini-css-extract-plugin
export default {"container":"Team_container__goNUv","team":"Team_team__5kCIo","padding":"Team_padding__5UGHe"};